import { TextMenu } from "common/components";
import { IconWrapper } from "common/components/icon";
import { colors } from "common/const/colors";
import styled from "styled-components";
import { HiddenRadio } from "./FormInputs";

const StyledRadioLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  cursor: pointer;
`;

export const RadioItem = ({
  inputRef,
  name,
  label,
  value,
  checked,
  disabled,
  onSelect,
}) => {
  const borderColor = disabled
    ? colors.Gray
    : checked
      ? colors.MainBlue
      : colors.LightNavy;
  const borderWidth = !checked && !disabled ? 9.5 : 6;
  const fillColor = checked
    ? colors.White
    : disabled
      ? colors.Gray
      : colors.White;

  return (
    <StyledRadioLabel>
      <HiddenRadio
        ref={inputRef}
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={() => onSelect(value)}
        readOnly
      />
      <IconWrapper size="1.25rem">
        <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <circle cx="10" cy="10" r="10" fill={borderColor} />
          <circle cx="10" cy="10" r={borderWidth} fill={fillColor} />
        </svg>
      </IconWrapper>
      <TextMenu
        style={{ color: disabled ? colors.LightNavy : colors.DarkNavy }}>
        {label}
      </TextMenu>
    </StyledRadioLabel>
  );
};
